import angular from 'angular';

angular.module('workflows.filters', []);

    angular.module('workflows.filters')
        .filter('workflowFilter', function () {
            return function (items, search) {
                if (!search || search.keyVal == "") {
                    return items;
                }
                var keyVal = search.keyVal.toLowerCase();
                if(search.byVal == "Action"){
                    return items.filter(function (element, index, array) {
                        return element.workflowActionName.toLowerCase().indexOf(keyVal) >= 0;
                    });
                }else if(search.byVal == "Status"){
                    return items.filter(function (element, index, array) {
                        return element.statusName.toLowerCase().indexOf(keyVal) >= 0;
                    });
                }else {
                    return items;
                }
            };
        });
